import type { CodeableConcept } from '@medplum/fhirtypes'
import { addBusinessDays } from 'date-fns'
import type { Order } from '#src/models/orders/index.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import {
  StandardTask,
  type StandardTaskParams,
} from '#src/models/tasks/standard/standardTask.ts'
import { ROLES, Role } from '#src/roles.ts'
import { now, recordKeys } from '#src/utils.ts'

export class VendorOrderPlacementTask extends StandardTask {
  static defaultRoles = recordKeys(ROLES).filter((r) => r !== Role.PCP)

  constructor({
    order,
    ...rest
  }: StandardTaskParams & {
    order: Order
  }) {
    super({
      code: VendorOrderPlacementTask.code,
      priority: order.urgent ? 'stat' : 'urgent',
      focus: order.reference,
      requester: order.signedBy,
      owner: order.requester,
      ...rest,
    })
    this.title = 'Place Order With Vendor'
    this.description = 'Place an order with the external vendor'
    this.state = 'todo'
    this.participant = order.participant
    this.dueOn = order.urgent
      ? addBusinessDays(now(), 1).toISOString()
      : addBusinessDays(now(), 2).toISOString()
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.VENDOR_ORDER_PLACEMENT
  }
}
